import UserActions from "../Types";

const initialState = {
    isEditing: false,
    editSuccess: false,
    editedStaff: {},
    isDeleting: false,
    deleteSuccess: false,
    deletedStaff: {},
    isGettingAllStaff: false,
    getAllStaffSuccess: false,
    allStaff: [],
    isUpdatingUser: false,
    updateUserSuccess: false,
    updatedUser: {},
    isChanging: false,
    changePasswordSuccess: false,
    changedPassword: {},
    error: null
}

export default (state = initialState, action) => {
    switch(action.type){
        case UserActions.EDIT_STAFF_START:
            return {
                ...state,
                isEditing: true,
                editSuccess: false,
                error: null
            }
        case UserActions.EDIT_STAFF_SUCCESS:
            return {
                ...state,
                isEditing: false,
                editSuccess: true,
                editedStaff: action.payload,
                error: null
            }
        case UserActions.EDIT_STAFF_FAILURE:
            return {
                ...state,
                isEditing: false,
                editSuccess: false,
                error: action.payload
            }
        case UserActions.DELETE_STAFF_START:
            return {
                ...state,
                isDeleting: true,
                deleteSuccess: false,
                error: null
            }
        case UserActions.DELETE_STAFF_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                deleteSuccess: true,
                deletedStaff: action.payload,
                error: null
            }
        case UserActions.DELETE_STAFF_FAILURE:
            return {
                ...state,
                isDeleting: false,
                deleteSuccess: false,
                error: action.payload
            }
        case UserActions.GET_ALL_STAFF_START:
            return {
                ...state,
                isGettingAllStaff: true,
                getAllStaffSuccess: false,
                error: null
            }
        case UserActions.GET_ALL_STAFF_SUCCESS:
            return {
                ...state,
                isGettingAllStaff: false,
                getAllStaffSuccess: true,
                allStaff: action.payload,
                error: null
            }
        case UserActions.GET_ALL_STAFF_FAILURE:
            return {
                ...state,
                isGettingAllStaff: false,
                getAllStaffSuccess: false,
                error: action.payload
            }
        case UserActions.CHANGE_PASSWORD_START:
            return {
                ...state,
                isChanging: true,
                changePasswordSuccess: false,
                error: null
            }
        case UserActions.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                isChanging: false,
                changePasswordSuccess: true,
                changedPassword: action.payload,
                error: null
            }
        case UserActions.CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                isChanging: false,
                changePasswordSuccess: false,
                error: action.payload
            }
        case UserActions.UPDATE_USER_START:
            return {
                ...state,
                isUpdatingUser: true,
                updateUserSuccess: false,
                error: null
            }
        case UserActions.UPDATE_USER_SUCCESS:
            return {
                ...state,
                isUpdatingUser: false,
                updateUserSuccess: true,
                updatedUser: action.payload,
                error: null
            }
        case UserActions.UPDATE_USER_FAILURE:
            return {
                ...state,
                isUpdatingUser: false,
                updateUserSuccess: false,
                error: action.payload
            }
            case UserActions.RESET_USER_RESET:
                return {
                    ...state,
                    isEditing: false,
                    editSuccess: false,
                    editedStaff: {},
                    isDeleting: false,
                    deleteSuccess: false,
                    deletedStaff: {},
                    isGettingAllStaff: false,
                    getAllStaffSuccess: false,
                    allStaff: [],
                    isUpdatingUser: false,
                    updateUserSuccess: false,
                    updatedUser: {},
                    isChanging: false,
                    changePasswordSuccess: false,
                    changedPassword: {},
                    error: null
                }
        default:
            return state;
    }
}